import { UserState } from './types';

export const AUTH_STATE = {
  NOT_AUTH: 0, // 未授权
  AUTHING: 1, // 授权中
  CANCEL: 2, // 授权取消
  EXPIRED: 3, // 授权过期
};

const thirdpartyInfo = {
  jushuitan: {},
  kuaimai: {},
};
type ThirdpartyListKey = keyof typeof thirdpartyGetterKey;
const thirdpartyGetterKey = {
  jushuitan: 'isAuthByJST',
  kuaimai: 'isAuthByKM',
};

const thirdpartyIsAuth = Object.keys(thirdpartyInfo).reduce(
  (acc: any, key: string) => {
    const getterKey = thirdpartyGetterKey[key as ThirdpartyListKey];
    acc[getterKey] = (state: UserState) =>
      state[key as ThirdpartyListKey]?.authState === AUTH_STATE.AUTHING;
    return acc;
  },
  {}
);

const otherThirdpartyGetters = {
  // 是否有第三方授权
  isAuthByThirdparty(state: UserState) {
    return state.thirdpartyInfo.find(
      (item) => item.authState === AUTH_STATE.AUTHING
    );
  },
  // 是否授权聚水潭，并且授权未过期
  isAuthValidByJST(state: UserState): () => boolean {
    return () => {
      if (state.jushuitan?.authState !== AUTH_STATE.AUTHING) return false;
      return state.jushuitan.expirationTime - Date.now() > 0;
    };
  },
};

export default {
  thirdpartyInfo,
  thirdpartyGetters: {
    ...thirdpartyIsAuth,
    ...otherThirdpartyGetters,
  },
};
